import { cartHelper, cartServices } from 'src/services';
import { Dispatch, FC, SetStateAction } from 'react';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { months } from '@monorepo/helpers';
import { typeCartAssignment, typeCartPeriod, typeCartPoint, typeCartsDoc } from '@monorepo/models';
import { useDispatch } from 'react-redux';

type propsType = {
    cartsDoc: typeCartsDoc;
    month: number;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
    year: number;
};

export const CartAssignmentReplicate: FC<propsType> = ({ cartsDoc, month, setRefreshCounter, year }) => {
    const dispatch = useDispatch();

    const replicateLastMonth = () => {
        if (!year || !month) {
            return;
        }
        const previousMonth = month === 0 ? 11 : month - 1;
        const previousYear = month === 0 ? year - 1 : year;
        const assignmentsPreviousMonth = cartsDoc.assignments.filter(a => a.year === previousYear && a.month === previousMonth);
        if (!assignmentsPreviousMonth.length) {
            dispatch(setValuesAndOpenAlertModalReducer({
                mode: 'alert',
                title: 'No hay asignaciones en el mes anterior',
                message: '',
                animation: 2
            }));
            return;
        }
        const assignments: typeCartAssignment[] = [];
        for (const assignment of assignmentsPreviousMonth) {
            const period: typeCartPeriod = {
                endHour: assignment.endHour,
                endMinutes: assignment.endMinutes,
                id: 0,
                startHour: assignment.startHour,
                startMinutes: assignment.startMinutes
            };
            const point = { id: assignment.pointId } as typeCartPoint;
            if (cartHelper.IsOverlappingPoint(cartsDoc, month, period, point, assignment.weekday, year)) {
                continue;
            }
            const participantIds = cartsDoc.participants.map(p => p.userId!);
            if (!participantIds.includes(assignment.participants[0].userId) || !participantIds.includes(assignment.participants[1].userId)) {
                continue;  // some participant was removed
            }
            if (cartHelper.IsOverlappingParticipant(cartsDoc, month, assignment.participants, period, point, assignment.weekday, year)) {
                continue;
            }
            assignments.push({
                ...assignment,
                month,
                year
            });
        }
        if (!assignments.length) {
            dispatch(setValuesAndOpenAlertModalReducer({
                mode: 'alert',
                title: 'No hay asignaciones en el mes anterior que no se superpongan con otras del actual mes',
                message: ''
            }));
            return;
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: 'Confirmar',
            message: `Se van a replicar las asignaciones del mes ${months[previousMonth]}/${previousYear} en ${months[month]}/${year} (son ${assignments.length})`,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await cartServices.AddAssignments(assignments);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                setRefreshCounter(x => x + 1);
            }
        }));
    }

    return (
        <>
        {new Date(year, month).getTime() >= new Date(new Date().getFullYear(), new Date().getMonth()).getTime() &&
            <div className={'text-end mb-4'}>
                <button className={'btn btn-general-red'} onClick={replicateLastMonth}>
                    Replicar asignaciones del mes pasado
                </button>
            </div>
        }
        </>
    );
}
